module.exports = __webpack_public_path__ + "static/media/read_content_aloud_eng.272ba492.mp3";